/**
 * Discover Banner — CTA buttons navigate via data attributes (same pattern as teaser banner).
 */
import { syncCtaAriaLabel } from './utils/lvzCtaA11y';

(function initLvzDiscoverBanner() {
	/**
	 * @param {HTMLButtonElement} button
	 */
	function navigate(button) {
		const href = button.getAttribute('data-lvz-cta-href');
		const target = button.getAttribute('data-lvz-cta-target') || '_self';
		if (!href) {
			return;
		}
		if (target === '_blank') {
			window.open(href, '_blank', 'noopener,noreferrer');
		} else {
			window.location.assign(href);
		}
	}

	/**
	 * @param {HTMLButtonElement} button
	 */
	function initOne(button) {
		syncCtaAriaLabel(button);
		button.addEventListener('click', function onDiscoverCtaClick(e) {
			e.preventDefault();
			navigate(button);
		});
	}

	function boot() {
		document.querySelectorAll('[data-lvz-discover-banner] [data-lvz-cta-button]').forEach(function (el) {
			initOne(el);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
